var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bug-button",on:{"click":_vm.openBugReportModal}},[_c('v-icon',{staticClass:"bug-button__icon",attrs:{"size":"22","color":"white"}},[_vm._v("mdi-alert")]),_c('span',[_vm._v("Сообщить о проблеме")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }